import React from 'react';
import './index.scss';
import { useTranslation } from 'react-i18next';

const HCPNote = () => {
  const { t } = useTranslation();
  return (
    <div className="HCPNote">
      <div className="iconImg">
        <img
          src="/content/images/icons/HCPIcon.svg"
          width="158"
          height="158"
          alt=""
        />
      </div>
      <h3 className="headingLabel">{t('HCP heading')}</h3>
      <ul>
        <li>{t('HCP note1')}</li>
        <li>{t('HCP note2')}</li>
      </ul>
    </div>
  );
};

export default HCPNote;
